<template>
    <div class="modal-mask">
        <div class="modal-wrapper" id="chat">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">close</a>
                        </section>
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{ $t('1101') }}
                                <!-- 구매 정보 -->
                            </div>
                        </section>
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>

                <section class="flex-grow-1" id="chatContainer" ref="chatContainer">
                    <chat-list :listData="listData"></chat-list>
                    <div ref="scrollBottom"></div>
                    <div></div>
                </section>

                <section id="messageContainer2" ref="msgContainerRef">
                    <chat-write :learnId="learnId" :lessonId="lessonId" :roomId="roomId" :examineeId="examineeId"
                        :questionId="questionId" @updateListData="updateListData"></chat-write>
                </section>
            </div>
            <infinite-loading @infinite="fetchData" spinner="spiral"></infinite-loading>
        </div>
    </div>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 메인 컴포넌트(my learn / exam question - main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import chatApi from '@/api/chatApi.js'
import ChatList from './ChatList.vue'
import ChatWrite from './ChatWrite.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    components: {
        'chat-list': ChatList,
        'chat-write': ChatWrite,
        InfiniteLoading,
    },
    data() {
        return {
            learnId: null,
            lessonId: null,
            roomId: null,

            examineeId: null,
            questionId: null,

            entered: false,
            listData: [],
            currentPage: 1,
            totalPages: 1
        }
    },

    computed: {
    },

    mounted() {
        const chatContainer = window.document.querySelector("#chatContainer");
        setTimeout(() => {
            chatContainer.scrollTo({top: chatContainer.scrollHeight})            
        }, 500);
    },

    methods: {
        fetchData($state) {
            if (this.$route.meta.chatType === 'exam') {
                this.fetchExamChatData($state);
            } else {
                this.fetchLearnChatData($state);
            }
        },

        // set parameter for learn question
        setParamsLearn() {
            let params = {
                learnId: this.learnId,
                lessonId: this.lessonId,
                roomId: this.roomId,
                page: this.currentPage,
                size: 50,
                sort: 'id,desc'
            }
            return params
        },

        // set parameter for exam question
        setParamsExam() {
            let params = {
                examineeId: this.examineeId,
                questionId: this.questionId,
                roomId: this.roomId,
                page: this.currentPage,
                size: 50,
                sort: 'id,desc'
            }
            return params
        },


        moveScrollBottom() {
            let element = this.$refs.scrollBottom
            let options = {
                container: '#chatContainer',
                easing: 'ease-in'
            }
            this.$scrollTo(element, 100, options)
        },

        // update chatting list data
        updateListData(data) {
            this.listData.push(data)
            this.roomId = data.roomId
            this.moveScrollBottom()
        },

        // get chatting list data for exam
        fetchExamChatData($state) {
            this.examineeId = this.$route.params.examineeId
            this.questionId = this.$route.params.questionId

            let params = {
                examineeId: this.examineeId,
                questionId: this.questionId
            }

            chatApi.examChatroomQuestion(params).then((response) => {
                this.entered = response.data.data.entered
                this.roomId = response.data.data.id
                if (response.data.data.entered) {
                    params = this.setParamsExam()
                    if (this.totalPages >= this.currentPage) {
                        chatApi.examChatroomChatList(params).then((response) => {
                            let responseData = response.data.data
                            this.currentPage++
                            this.totalPages = responseData.totalPages
                            this.listData.unshift(...responseData.content.reverse());

                            if (responseData.content.length) {
                                $state.loaded()
                            } else {
                                $state.complete()
                            }

                            chatApi.examChatroomChatRead(params).then((response) => {
                                console.log('읽음처리 완료');
                            }).catch((err) => {

                            })
                        })
                    } else {
                        $state.complete()
                    }
                } else {
                    $state.complete()
                }

            }).catch((err) => {
            })
        },

        // get chatting list data for my learn
        fetchLearnChatData($state) {
            this.learnId = this.$route.params.learnId
            this.lessonId = this.$route.params.lessonId

            let params = {
                learnId: this.learnId,
                lessonId: this.lessonId
            }

            // get chatting room information
            chatApi.learnChatroomLesson(params).then((response) => {
                this.entered = response.data.data.entered
                this.roomId = response.data.data.id
                if (response.data.data.entered) {
                    params = this.setParamsLearn()

                    if (this.totalPages >= this.currentPage) {
                        // get chatting list
                        chatApi.learnChatroomChatList(params).then((response) => {
                            let responseData = response.data.data
                            this.currentPage++
                            this.totalPages = responseData.totalPages
                            this.listData.unshift(...responseData.content.reverse());

                            if (responseData.content.length) {
                                $state.loaded()
                            } else {
                                $state.complete()
                            }

                            // set readed
                            chatApi.learnChatroomChatRead(params).then((response) => { }).catch((err) => { })
                        })
                    } else {
                        $state.complete()
                    }

                } else {
                    $state.complete()
                }

            }).catch((err) => { })
        }
    }
}
</script>

<style scoped>
.modal-mask .modal-wrapper {
    height: 100%;
    overflow: hidden;
}
</style>
